const METRIKA_ID = 112037019;

declare global {
  interface Window {
    ym?: (id: number, method: string, ...args: unknown[]) => void;
    dataLayer?: unknown[];
  }
}

export function trackHit(url: string) {
  if (typeof window.ym === 'function') {
    window.ym(METRIKA_ID, 'hit', url);
  }
}

export function trackAddToCart(product: { id: string; name: string; price: number; quantity: number }) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    ecommerce: {
      add: {
        products: [
          {
            id: product.id,
            name: product.name,
            price: product.price,
            quantity: product.quantity
          }
        ]
      }
    }
  });
}

export function trackPurchase(order: {
  orderNumber: string;
  total: number;
  items: Array<{ id?: string; name: string; price: number; quantity: number }>;
}) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    ecommerce: {
      purchase: {
        actionField: {
          id: order.orderNumber,
          revenue: order.total
        },
        products: order.items.map(item => ({
          id: item.id,
          name: item.name,
          price: item.price,
          quantity: item.quantity
        }))
      }
    }
  });
}
